import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  UnavailabilitiesFilter,
  Unavailability,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  unavailabilities: Identifiable<Unavailability>[];
  retrieveUnavailabilities(
    request: Boundaries["retrieveUnavailabilities"]["request"],
  ): void;
}

function useRetrieveUnavailabilities(
  filter: UnavailabilitiesFilter,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveUnavailabilitiesRequestPending(filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveUnavailabilitiesRequestSuccess(filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveUnavailabilitiesRequestFailure(filter),
    ),
    unavailabilities: useSelector(() => selector.getUnavailabilities(filter)),
    retrieveUnavailabilities: core.retrieveUnavailabilities,
  };
}

export { useRetrieveUnavailabilities };
